class BackInStockAlert extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.statusElement = this.querySelector(".back-in-stock-alert__status");

    if (!this.form || this.dataset.initialized === "true") {
      return;
    }

    this.dataset.initialized = "true";
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.form.reportValidity()) {
      return;
    }

    const submitButton = this.form.querySelector('[type="submit"]');
    const formData = new FormData(this.form);
    const siteId = this.getAttribute("klaviyo-site-id")?.trim();
    const email = formData.get("email")?.trim();
    const variantId = formData.get("variant_id")?.trim();

    if (formData.get("company")) {
      this.form.reset();
      this.setStatus(this.successMessage, "success");
      return;
    }

    if (!siteId || !email || !variantId) {
      this.setStatus(this.errorMessage, "error");
      return;
    }

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email
              }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };

    submitButton?.setAttribute("aria-busy", "true");
    submitButton?.setAttribute("disabled", "");
    this.setStatus("");

    try {
      const endpoint = new URL("https://a.klaviyo.com/client/back-in-stock-subscriptions/");
      endpoint.searchParams.set("company_id", siteId);

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          revision: "2026-07-15"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Subscription failed with status ${response.status}`);
      }

      this.form.querySelectorAll("input:not([type='hidden'])").forEach((input) => {
        input.disabled = true;
      });
      submitButton?.setAttribute("hidden", "");
      this.setStatus(this.successMessage, "success");
    } catch (error) {
      console.error("Back-in-stock subscription failed", error);
      this.setStatus(this.errorMessage, "error");
    } finally {
      submitButton?.removeAttribute("aria-busy");

      if (!submitButton?.hasAttribute("hidden")) {
        submitButton?.removeAttribute("disabled");
      }
    }
  }

  setStatus(message, status = "") {
    if (!this.statusElement) {
      return;
    }

    this.statusElement.textContent = message;
    this.statusElement.dataset.status = status;
  }

  get successMessage() {
    return this.getAttribute("success-message") || "Richiesta ricevuta.";
  }

  get errorMessage() {
    return this.getAttribute("error-message") || "Non è stato possibile registrare la richiesta.";
  }
}

if (!window.customElements.get("back-in-stock-alert")) {
  window.customElements.define("back-in-stock-alert", BackInStockAlert);
}
